import { useEffect } from 'react';
import { useMachine } from '../../state/machine.ts';
import { useCamera } from '../../hooks/useCamera.ts';
import s from './Permission.module.css';

export function Permission() {
  const send = useMachine((m) => m.send);
  const machineState = useMachine((m) => m.state);
  const cam = useCamera();

  useEffect(() => {
    if (cam.status === 'granted') send('PERMISSION_GRANTED');
    if (cam.status === 'denied') send('CAMERA_DENIED');
  }, [cam.status, send]);

  const isDenied = machineState === 'permission-denied';

  return (
    <main className={s.root}>
      <div className={s.card}>
        <h2 className={s.title}>{isDenied ? 'camera blocked' : 'we need your camera'}</h2>
        <p className={s.body}>
          The next screen calibrates the model and warms up the arena. Your
          stream stays on your device until matchmaking pairs you with someone.
        </p>
        <ul className={s.list}>
          <li>Frontal face, well-lit if possible</li>
          <li>One person in frame</li>
          <li>10 seconds, then it's over</li>
        </ul>
        {isDenied ? (
          <p className={s.deny}>
            Browser blocked the camera. Open the site permissions and re-enable,
            then click below.
          </p>
        ) : null}
        <button
          type="button"
          className={s.cta}
          onClick={() => void cam.request()}
          disabled={cam.status === 'requesting'}
        >
          {cam.status === 'requesting' ? 'asking…' : 'enter calibration'}
        </button>
        <button type="button" className={s.back} onClick={() => send('BACK_TO_LANDING')}>
          back
        </button>
      </div>
    </main>
  );
}
